module.exports = __webpack_public_path__ + "static/mondelez-84a158510b63e65f1c17d45eada85cc4.svg";